import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { applicationPaths, localStorageKeys, screenDetails } from '../../../../Models/configurations';
import { UtilityServices } from '../../../../Services/utility.services';
import { progressStepNames } from './../../../../Models/progress-bar-step';
import { AppsettingService } from './../../../../Services/appsetting.service';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { CheckInDataService } from 'projects/Check-In/src/app/Services/check-in-data.service';

@Component({
  selector: 'app-third-step',
  templateUrl: './third-step.component.html',
  styleUrls: ['./third-step.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ThirdStepComponent implements OnInit {
  urlName: string;
  userPrivacy: FormGroup;
  IsSubmitted = false;
  customerDetail: any;
  policyConsent: any;
  privacyConsent: any;
  public steps: any;
  public activeStepName: string;
  public activeStepCompleted: boolean;


  constructor(
    private formBuilder: FormBuilder,
    private readonly utilityService: UtilityServices,
    private readonly appsettingService: AppsettingService,
    private readonly secureStorageService: SecureStorageService,
    private cdrf: ChangeDetectorRef,
    private secureStorage: SecureStorage,
    private translate: TranslateService,
    private readonly checkInDataService: CheckInDataService
  ) {
    this.urlName = '/' + applicationPaths.seven;
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) !== undefined) {
      this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    }
    this.userPrivacy = this.formBuilder.group({
      userPrivacyAccept: new FormControl(false, Validators.requiredTrue)
    });
  }

  public userPrivacyFormSubmit() {
    this.IsSubmitted = true;
    this.secureStorageService.removeKey(localStorageKeys.privacyConsent);
    this.secureStorageService.setKeyData(localStorageKeys.privacyConsent, this.f.userPrivacyAccept.value);
    this.activeStepCompleted = true;
    this.activeStepName = progressStepNames.stepName4;
    this.appsettingService.stepCompletion(this.activeStepName, this.activeStepCompleted);
    this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    this.cdrf.detectChanges();
    this.moveNext();
  }

  get f() { return this.userPrivacy.controls; }

  public moveNext(): void {
    this.urlName = this.appsettingService.getScreenConfiguration(screenDetails.stepThree);
    this.utilityService.navigateToNext(this.urlName);
  }

  public verificationDetails(): void {
    let data = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    this.policyConsent = data.dealerDetail; 
    this.privacyConsent= this.secureStorage.getKeyData('TermsConditionData');
    this.setOwernVerifcationValue();
  }

  private setOwernVerifcationValue() {
    const val = this.secureStorageService.getKeyData(localStorageKeys.privacyConsent);
    if (val !== undefined) {
      this.userPrivacy.patchValue({ "userPrivacyAccept": val });
    }
  }

  ngOnInit(): void {
    this.checkInDataService.GetCheckInModuleData().subscribe(data => {
      if (data) {
        if (data['isCheckInNotAllowed']) {
          this.utilityService.navigateToNext('/' + applicationPaths.seven);
        }
        else{
          this.verificationDetails();
        }
      }
    });
  }
}
